import StaticPageRedirect from '../component/StaticPageRedirect';
export default function Privacy() { return <StaticPageRedirect page="privacy" />; }
